import styled, { css } from 'styled-components';

const ElementContainer = styled.div`
  display: flex;
  width: 100%;
  height: 5rem;
  ${({ col }) =>
    col &&
    css`
      flex-direction: column;
    `}
  ${({ row }) =>
    row &&
    css`
      flex-direction: row;
    `};
`;

export { ElementContainer };
